import React, { useState } from 'react';
import UsersManager from './views/UsersManager';
import ProfessionalsManager from './views/ProfessionalsManager';
import AdminNavigation from './AdminNavigation'; // Make sure the import path is correct
import './style/admin.css';

export default function AdminDashBoard() {
  const [currentTab, setCurrentTab] = useState('professionals');

  return (<div className="admin-container">
      {/* 1. Left Column Navigation: Spans full screen height via modern CSS Grid column 1 */}
      <aside className="admin-sidebar">
        <AdminNavigation />
      </aside>

      {/* 2. Right Side Column Flow Stack: Content handles all horizontal sub-rows cleanly inside column 2 */}
      <div className="admin-body-wrapper">
        <header className="admin-header">
          <button 
            className={`tab-button ${currentTab === 'professionals' ? 'active' : ''}`} 
            onClick={() => setCurrentTab('professionals')}
          >
            Professionals
          </button>
          <button className={`tab-button ${currentTab === 'users' ? 'active' : ''}`} 
            onClick={() => setCurrentTab('members')}
          >
            Users
          </button>
        </header>

        {/* Dynamic Inner Manager Panel */}
        <main className="admin-main-content">
          {currentTab === 'professionals' ? <ProfessionalsManager /> : <UsersManager />}
        </main>
      </div>
    </div>
  );
}